import { NavigateFunction } from "react-router-dom";
import useHomeStore, { IHomeState } from "./store";

export class Handlers {
  private homeStore: IHomeState;
  private navigate: NavigateFunction;

  constructor(navigate: NavigateFunction) {
    this.homeStore = useHomeStore.getState();
    this.navigate = navigate;
  }

  handleModalClose = () => {
    this.homeStore.setAddModal(false);
  };

  handleOpenProduct = (url: string) => {
    return window.open(url, "_blank", "noopener,noreferrer");
  };
}
